import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CartItem } from '../interface/cart.interface';
import { PromotionVoucher } from '../interface/menu.interface';
import { CartService } from '../service/cart.service';
import { CommonService } from '../service/common.service';
import { UserService } from '../service/user.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit, AfterViewInit, OnDestroy {

  cart: CartItem[];
  private unsubscribe$ = new Subject();

  constructor(
    private cartService: CartService,
    private userService: UserService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.getcartv2();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.cartService.cart$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        if(!data) {
          return;
        }
        this.cart = data;
      });
    });
  }

  getcartv2(): void {
    this.cartService.getCartV2().subscribe();
  }

  removeCartItem(itemIndex: number): void {
    const item = this.cart ? this.cart[itemIndex] : null;
    if (!item) return;

    if(this.userService.isVoucherSelected()) {
      let dialogResponse = this.commonService.actionDialog('Alert', 'Changing quantity or removing a product will require you to apply a voucher again.', 'Proceed');
      dialogResponse.subscribe(data => {
        if(data) {
          this.userService.removeVoucher();
          this.doRemoveCartItem(item, itemIndex);
        }
      });
      return;
    }
    this.doRemoveCartItem(item, itemIndex);
  }

  private doRemoveCartItem(item: any, itemIndex: number): void {
    const itemId = item.item_id ?? item.cart_item_id ?? item.product_id ?? item.prod_id;
    this.cartService.deleteCartItemV2(itemId).subscribe({
      next: (response) => {
        if (!response || !response.success) {
          // Fallback to update with 0
          this.cartService.updateCartItemV2(itemId, 0).subscribe({
            next: (res) => {
              if (!res || !res.success) {
                this.cartService.removeCartItem(itemIndex);
              }
            },
            error: () => this.cartService.removeCartItem(itemIndex)
          });
        }
      },
      error: () => {
        this.cartService.removeCartItem(itemIndex);
      }
    });
  }

  increaseQuantity(itemIndex: number): void {
    const item = this.cart ? this.cart[itemIndex] : null;
    if (!item) return;

    if(this.userService.isVoucherSelected()) {
      let dialogResponse = this.commonService.actionDialog('Alert', 'Changing quantity or removing a product will require you to apply a voucher again.', 'Proceed');
      dialogResponse.subscribe(data => {
        if(data) {
          this.userService.removeVoucher();
          this.updateQuantity(item, +item.quantity + 1);
        }
      });
      return;
    }
    this.updateQuantity(item, +item.quantity + 1);
  }

  decreaseQuantity(itemIndex: number): void {
    const item = this.cart ? this.cart[itemIndex] : null;
    if (!item || +item.quantity <= 1) return;

    if(this.userService.isVoucherSelected()) {
      let dialogResponse = this.commonService.actionDialog('Alert', 'Changing quantity or removing a product will require you to apply a voucher again.', 'Proceed');
      dialogResponse.subscribe(data => {
        if(data) {
          this.userService.removeVoucher();
          this.updateQuantity(item, +item.quantity - 1);
        }
      });
      return;
    }
    this.updateQuantity(item, +item.quantity - 1);
  }

  private updateQuantity(item: any, newQuantity: number): void {
    const originalQuantity = item.quantity;
    item.quantity = newQuantity;

    const itemId = item.item_id ?? item.cart_item_id ?? item.product_id ?? item.prod_id;
    this.cartService.updateCartItemV2(itemId, newQuantity).subscribe({
      next: (response) => {
        if (!response || !response.success) {
          item.quantity = originalQuantity;
        }
      },
      error: () => {
        item.quantity = originalQuantity;
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
